import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const useStyles = makeStyles((theme) => ({
  bluebutton: {
    background: "linear-gradient(90deg, #FFD9B5 0%, #FFEEC3 100%)",
    width: "40%",
    whiteSpace: "nowrap",
    color: "#243B55",
    "&:hover": {
      background: "linear-gradient(90deg, #FFD669 0%, #FFA046 100%)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
  },
}));

function BlockScreen() {
  const classes = useStyles();
  const navigate = useNavigate(); // Hook for navigation

  const handleReload = () => {
    navigate("/"); // Navigate to home page
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "24px",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      <Box sx={{ marginBottom: "10rem" }}>
        <Typography variant="h4">Screenshots are not allowed!</Typography>
        <Box height={"30px"}></Box>
        <Button className={classes.bluebutton} variant="contained" onClick={handleReload}>
          Go To Home Page
        </Button>
      </Box>
    </Box>
  );
}

export default BlockScreen;
